function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Widget");

var SvgWidget = function SvgWidget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M75.94,25.71H52.65a5.53,5.53,0,0,0-11.06,0H20.06a4,4,0,0,0-4,4V71.82a4,4,0,0,0,4,4H75.94a4,4,0,0,0,4-4V29.71A4,4,0,0,0,75.94,25.71ZM47.12,21.12a4.59,4.59,0,1,1-4.59,4.59A4.59,4.59,0,0,1,47.12,21.12ZM60.29,71.65a1.23,1.23,0,0,1-1.23,1.23H38.12a1.24,1.24,0,0,1-1.24-1.23V67.88a1.24,1.24,0,0,1,1.24-1.23H59.06a1.23,1.23,0,0,1,1.23,1.23Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWidget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WIDGET.5d4a9eca.svg";
export { ForwardRef as ReactComponent };